import { render, staticRenderFns } from "./Trader.vue?vue&type=template&id=3753f982&"
import script from "./Trader.vue?vue&type=script&lang=js&"
export * from "./Trader.vue?vue&type=script&lang=js&"
import style0 from "./Trader.vue?vue&type=style&index=0&id=3753f982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports